<template>
  <section class="w-panel w-branch-picker" aria-label="Выбор филиала">
    <h2>Выберите филиал</h2>
    <p class="w-small">
      {{ store.actorDoctor?.name }} · доступно филиалов: {{ store.branchOptions.length }}
    </p>
    <div class="w-branch-options">
      <button
        v-for="branch in store.branchOptions"
        :key="branch.id"
        class="w-button"
        type="button"
        @click="store.setBranch(branch.id)"
      >
        <q-icon name="apartment" />
        {{ branch.name }}
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useScheduleStore } from '@/store/calendar/scheduleModule';

const store = useScheduleStore();
</script>
